/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsListOl: {
  name: 'list-ol';
  data: string;
} = {
  name: 'list-ol',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V7a1 1 0 0 1-1-1Zm7 1a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H9Zm0 8a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H9Zm-6-2a1 1 0 1 0 0 2h1l-1.8 2.4A1 1 0 0 0 3 19h3a1 1 0 1 0 0-2H5l1.8-2.4A1 1 0 0 0 6 13H3Z" fill="currentColor"/></svg>`,
};
